import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import "react";
import { cleanProps, cn } from "../../utils/index.js";
import { CdnIcon } from "../CdnIcon/index.js";
const BaseSkeleton = ({ type, className, skeletonSlot, skeletonImageSlot, styles, ...props })=>{
    const isImage = 'image' === type;
    const skeletonClass = cn(skeletonSlot, className);
    return /*#__PURE__*/ jsx("output", {
        "aria-label": "loading",
        "data-testid": "skeleton",
        className: skeletonClass,
        ...cleanProps(props, [
            'type',
            'emphasis',
            'animate'
        ]),
        style: styles,
        children: isImage ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("div", {
                    className: skeletonImageSlot
                }),
                /*#__PURE__*/ jsx(CdnIcon, {
                    "data-testid": "loading-img",
                    iconName: "image",
                    size: "24",
                    className: "text-primary-6 relative",
                    "aria-hidden": "true"
                })
            ]
        }) : null
    });
};
export { BaseSkeleton };
